module.exports = __webpack_public_path__ + "img/bottom_bg.8aef959c.png";